import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery, themeVariant } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { Text } from '@components/typography';
import { Button } from '@components/Button';

const TITLE_WIDTH = {
  belowSm: '136px',
  sm: '220px',
  md: '280px',
};

export const StyledSection = styled(Box)`
  height: 96vh;
  position: relative;
  z-index: 1;
  contain: strict;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    max-height: 89vh;
  }
`;

export const HeroVideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
`;

export const HeroBodymovinWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const HeroVideoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: center center;
  overflow: hidden;
  > video {
    width: 100vw;
    height: 96vh;
    object-fit: cover;
    position: absolute;
    left: 0;
    ${themeMediaQuery('below_sm')} {
      max-height: 89vh;
    }
  }
  #registry-hero-video-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    background-color: #000;
    z-index: 3;
    opacity: 0.5;
  }
`;

export const HeroTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 440px;
  }
  .text-pairing-eyebrow {
    width: 310px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 520px;
    }
    .text-pairing-eyebrow {
      width: 100%;
    }
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      max-width: 90%;
    }
    .text-pairing-title {
      max-width: 90%;
    }
    .text-pairing-eyebrow {
      width: 90%;
    }
  }
`;

export const RegistryHeroTextColumn = styled(Columns)`
  position: relative;
  height: 100%;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  @media (max-width: 1024px) and (min-width: 768px) {
    margin-top: ${themeSpace(12)};
  }
`;

export const StyledButton = styled(Button)`
  ${themeMediaQuery('below_sm')} {
    padding: 0 15px;
    height: 45px;
    line-height: 43px;
  }
`;

export const ButtonsContainer = styled(Flex)`
  max-width: 620px;
  justify-content: center;
  > *:not(:first-child) {
    margin-left: ${themeSpace(10)};
  }
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    margin-top: ${themeSpace(6)};
    > *:not(:first-child) {
      margin-left: 0;
      margin-top: ${themeSpace(3)};
    }
  }
  margin-top: ${themeSpace(10)};
`;

export const RegistryHeroBottomWave = styled(CloudImage)`
  width: 110%;
  object-fit: cover;
  position: absolute;
  bottom: -10px;
  left: -5%;
  max-height: 200px;
  ${themeMediaQuery('below_sm')} {
    bottom: -2px;
    width: 110%;
  }
`;

export const StyledContainer = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  gap: ${themeSpace(5)};
  padding-left: ${themeSpace(7)};
  padding-right: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    padding: ${themeSpace(5)};
    min-width: 50%;
    gap: ${themeSpace(3)};
  }
`;

export const StyledButtonContainer = styled(Flex)`
  gap: ${themeSpace(9)};
  margin-top: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    gap: ${themeSpace(4)};
    flex-wrap: wrap;
    flex-direction: column;
  }
  ${themeMediaQuery('sm')} {
    gap: ${themeSpace(5)};
  }
  ${themeMediaQuery('md')} {
    gap: ${themeSpace(9)};
  }
`;

export const StyledFeature = styled(Text)`
  margin-left: ${themeSpace(6)};
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('caption')}
    margin-left: ${themeSpace(4)};
  }
  ${themeMediaQuery('tablet')} {
    ${themeVariant('featureCopy17')}
  }
`;

export const StyledTitle = styled(Text)`
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  left: 50%;
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('featureCopy17')}
    line-height: ${themeSpace(6)};
    width: ${TITLE_WIDTH.belowSm};
  }
  ${themeMediaQuery('tablet')} {
    ${themeVariant('dek24')}
    width: ${themeSpace(14)};
  }
  ${themeMediaQuery('sm')} {
    ${themeVariant('hed32')}
    width: ${TITLE_WIDTH.sm};
  }
  ${themeMediaQuery('md')} {
    width: ${TITLE_WIDTH.md};
    ${themeVariant('hed40')}
  }
  ${themeMediaQuery('xl')} {
    ${themeVariant('hed56')}
    width:${themeSpace(16)};
  }
`;
